import { render, staticRenderFns } from "./vivo.vue?vue&type=template&id=7d889f42&"
import script from "./vivo.vue?vue&type=script&lang=js&"
export * from "./vivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports